import { getPrefix as _getPrefix } from '../agency';

/**
 * Agency prefix
 */
export const getPrefix = () => `${_getPrefix()}dsp/`;
